/* @flow */
import QueryString from 'qs';
import xhr from 'xhr';
import Config from 'Config';

import Collection from 'lib/Collection';
import FaqSection from 'entities/FaqSection';

const URL = Config.Environment.R101_ZENDESK_URL;

export default class FaqSections extends Collection {
  initialize() {
    this.model = FaqSection;
  }

  parse(response: Object) {
    return response.map(section => FaqSection.fromJSON(section));
  }

  static fetch(options = {}) {
    return new Promise((resolve, reject) => {
      xhr({
        url: `${URL}/api/v2/help_center/sections?` + QueryString.stringify(options),
        method: 'GET',
      }, (err, response, body) => {
        let possiblyParsedBody = body;
        try {
          possiblyParsedBody = JSON.parse(body);
        } catch (e) {
          // Do nothing.
        }

        if (err || response.statusCode >= 400) {
          // TODO: Wrap the error response into something easier to use.
          reject(err || possiblyParsedBody || body);
        } else {
          resolve(this.fromJSON(possiblyParsedBody.sections));
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/collections/FaqSections.js